import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      light: '#3371ae',
      main: '#004e9a',
      dark: '#00366b',
      contrastText: '#ffffff'
    },
    secondary: {
      light: '#d58500',
      main: '#e38500',
      dark: '#e35020',
      contrastText: '#ffffff'
    },
    attention: {
      light: '#ff4040',
      main: '#FF0000',
      dark: '#bb0000',
      contrastText: '#ffffff'
    }
  },
  components: {
    MuiSelect: {
      defaultProps: {
        MenuProps: {
          MenuListProps: {
            style: {
              maxHeight: '224px'
            }
          }
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: '#fff',
          border: '1px solid #004e9a',
          borderRadius: '50%',
          '.MuiStepIcon-text': {
            fill: '#004e9a'
          },
          '&.Mui-active': {
            border: 'none',
            '.MuiStepIcon-text': {
              fill: '#fff'
            }
          },
          '&.Mui-completed': {
            color: '#e38500',
            border: 'none'
          }
        }
      }
    }
  }
});
